import { Injectable } from "@angular/core";
import { NgbTimeAdapter, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
const pad = (i: number): string => i < 10 ? `0${i}` : `${i}`;
// this sets the time picker control 'HH:mm' values
@Injectable()
export class NgbTimeStringAdapter extends NgbTimeAdapter<string> {
  readonly DELIMITER = ':';
  fromModel(value: string| null): NgbTimeStruct | null {
    if (!value) {
      return null;
    }
    const split = value.split(':');
    return {
      hour: parseInt(split[0], 10),
      minute: parseInt(split[1], 10),
      second: parseInt(split[2], 10)
    };
  }
  toModel(time: NgbTimeStruct | null): string | null {
    return time != null ? `${pad(time.hour)}${this.DELIMITER}${pad(time.minute)}${this.DELIMITER}${pad(time.second)}` : null;
  }
}